import { render, staticRenderFns } from "./SamInput.vue?vue&type=template&id=1fba1de7&scoped=true&"
import script from "./SamInput.vue?vue&type=script&lang=js&"
export * from "./SamInput.vue?vue&type=script&lang=js&"
import style0 from "./SamInput.vue?vue&type=style&index=0&id=1fba1de7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fba1de7",
  null
  
)

export default component.exports